import { toPng, toSvg } from 'html-to-image';
import { jsPDF } from 'jspdf';
import FileSaver from 'file-saver';
import { ExportFormat } from '../types';

export async function exportFlowchart(
  flowchartRef: HTMLElement, 
  format: ExportFormat, 
  filename = 'flowchart'
): Promise<void> {
  if (!flowchartRef) {
    throw new Error('Flowchart reference is not available');
  }

  try {
    switch (format) {
      case 'png':
        const pngDataUrl = await toPng(flowchartRef, { quality: 0.95 });
        FileSaver.saveAs(pngDataUrl, `${filename}.png`);
        break;

      case 'svg':
        const svgDataUrl = await toSvg(flowchartRef);
        FileSaver.saveAs(svgDataUrl, `${filename}.svg`);
        break;

      case 'pdf':
        const pdfDataUrl = await toPng(flowchartRef, { quality: 0.95 });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          throw new Error('Canvas context is not available');
        }
        
        const img = new Image();
        img.onload = () => {
          // Calculate dimensions for the PDF
          const imgWidth = img.width;
          const imgHeight = img.height;
          const ratio = imgWidth / imgHeight;
          
          let pdfWidth = 210; // A4 width in mm
          let pdfHeight = pdfWidth / ratio;
          
          // If the height is too large for A4, adjust the dimensions
          if (pdfHeight > 297) { // A4 height in mm
            pdfHeight = 297;
            pdfWidth = pdfHeight * ratio;
          }
          
          const pdf = new jsPDF({
            orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
            unit: 'mm',
          });
          
          pdf.addImage(pdfDataUrl, 'PNG', 
            (210 - pdfWidth) / 2, // Center horizontally
            (297 - pdfHeight) / 2, // Center vertically
            pdfWidth, 
            pdfHeight
          );
          
          pdf.save(`${filename}.pdf`);
        };
        
        img.src = pdfDataUrl;
        break;

      default:
        throw new Error(`Unsupported export format: ${format}`);
    }
  } catch (error) {
    console.error('Error exporting flowchart:', error);
    throw error;
  }
} 